import { type ReactElement, type SVGProps } from 'react';

export const PlusNaked = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12.5 11.5L12.5 4H11.5L11.5 11.5L4 11.5V12.5L11.5 12.5L11.5 20H12.5L12.5 12.5L20 12.5V11.5L12.5 11.5Z" fill="currentColor" />
    </svg>
  );
};
